import arrow from "assets/ic_arrow_white.png";
import useGoBack from "pages/Common/Hook/useGoBack";
import React from "react";
import Flex from "../Flex/Flex";
import "./bottomBar.scss";
const BottomBar = ({
  yellowTheme = false,
  text = "돌아가기",
  onClick: handleClick,
  disabled = false,
  backTheme = false,
  style = {},
  backAction = false,
}) => {
  const commonBack = useGoBack();
  return (
    <div className={`bottom-bar`}>
      <div
        style={style}
        className={`bottom-bar-main 
        ${yellowTheme || backTheme ? "vat-theme" : ""} 
        ${disabled ? "disabled" : ""} 
        ${backTheme ? "has-arrow" : ""}
        `}
        onClick={() => {
          if (!disabled) {
            if (backTheme && handleClick) {
              // backTheme 사용하더라도 handleClick이 있으면 그것을 우선으로 함
              handleClick?.();
            } else if ((backTheme || backAction) && !handleClick) {
              commonBack();
            } else {
              handleClick?.();
            }
          }
        }}
      >
        {backTheme && (
          <Flex style={{ width: 50 }} className="h-100 hover">
            <img src={arrow} alt="" width={10} className="m-auto" />
          </Flex>
        )}
        <div>{text}</div>
        {backTheme && <div style={{ width: 50 }} />}
      </div>
    </div>
  );
};

export default BottomBar;
